import React, { useState } from "react";
import PaymentMethodsImages from "../assets/payment-methods.png";
import { EmployeeFirstFormApi } from "../services/Api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
function EmployeeFirstPlan() {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    organization: "",
    officialEmail: "",
    contactNumber: "",
    designation: "",
    existingEWP: false,
  });

  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async () => {
    const { name, organization, officialEmail, contactNumber, designation } =
      formData;
    if (
      !name ||
      !organization ||
      !officialEmail ||
      !contactNumber ||
      !designation
    ) {
      setError("Please fill in all required fields.");
      return;
    }

    const response = await EmployeeFirstFormApi(formData);
    if (response?.status === "success") {
      setShowModal(false);
      toast.success(response.message)
    } else if (
      response?.status === "failure" ||
      response?.status === "failed"
    ) {
            toast.error(response.message)

      setError(response.message);
    } else {
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="employee-care-plan-container">
      <div className="employee-care-plan-left">
        <h2 className="employee-care-plan-title">Designed For:</h2>
        <p className="employee-care-plan-desc">"People & Culture Teams"</p>
        <p className="employee-care-plan-desc">"HR and L&D Leaders"</p>
        <p className="employee-care-plan-desc">
          "Founders and CXOs who care beyond KPIs"
        </p>

        <div className="employee-care-plan-payments">
          <h4>Payment Methods</h4>
          <img
            src={PaymentMethodsImages}
            alt="Payment Methods"
            className="employee-care-plan-payments-img"
          />
          <p className="employee-care-plan-note">
            We accept Visa, American Express, Mastercard, Paypal and Crypto
          </p>
        </div>
      </div>

      <div className="employee-care-plan-right">
        <div className="employee-care-plan-card-alt">
          <p className="employee-care-plan-label white">Voice calls</p>
          <p className="employee-care-plan-label white">Video calls</p>
          <button
            className="employee-care-plan-button-yellow"
            onClick={() => setShowModal(true)}
          >
            Contact Program Manager
          </button>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-xl shadow-lg w-full max-w-md">
            <h2 className="text-xl font-bold text-[#3CC3CD] mb-4 text-center">
              Contact Program Manager
            </h2>
            <div className="space-y-4">
              <input
                type="text"
                name="name"
                placeholder="Name*"
                value={formData.name}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded"
              />
              <input
                type="text"
                name="organization"
                placeholder="Organization*"
                value={formData.organization}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded"
              />
              <input
                type="email"
                name="officialEmail"
                placeholder="Official Email*"
                value={formData.officialEmail}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded"
              />
              <input
                type="tel"
                name="contactNumber"
                placeholder="Contact Number*"
                value={formData.contactNumber}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded"
              />
              <input
                type="text"
                name="designation"
                placeholder="Designation*"
                value={formData.designation}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded"
              />
              <label className="flex items-center gap-2 text-sm text-gray-600">
                <input
                  type="checkbox"
                  name="existingEWP"
                  checked={formData.existingEWP}
                  onChange={handleInputChange}
                />
                Already have an Employee Wellness Program?
              </label>
              {error && <p className="text-red-500 text-sm">{error}</p>}
            </div>

            <div className="mt-6 flex justify-end gap-4">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 border border-[#3CC3CD] text-[#3CC3CD] rounded hover:bg-[#f0fefe]"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-4 py-2 bg-[#3CC3CD] text-white rounded hover:bg-[#32b3b9]"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default EmployeeFirstPlan;
